module.exports = __webpack_public_path__ + "img/whds.3a062110.png";